// GENERATO da BLACKWAVE/tools/gen_editor_scopes.js — NON editare a mano.
// Tabelle numeriche per gli specchietti (scope) dell'editor: curve ADSRv2 e mappa
// tempi CV->tuning word, estratte da resources/ENV.ASM (Electric Druid VCADSR v8).
// Rigenerare a ogni modifica dell'algoritmo ADSRv2. Vedi scopeEngines.js per l'uso.

// AttackCurve: 257 entry 16bit, 0 -> 65535 (crescente). Upsampling a runtime.
export const ADSR_ATTACK_257 = new Uint16Array([
  0, 487, 970, 1451, 1930, 2405, 2878, 3348, 3816, 4281, 4743, 5202,
  5659, 6113, 6565, 7014, 7461, 7905, 8346, 8785, 9222, 9655, 10087, 10516,
  10942, 11366, 11788, 12207, 12624, 13039, 13451, 13861, 14268, 14673, 15076, 15476,
  15875, 16271, 16664, 17056, 17445, 17832, 18217, 18599, 18979, 19358, 19734, 20108,
  20479, 20849, 21216, 21582, 21945, 22306, 22666, 23023, 23378, 23731, 24082, 24431,
  24778, 25123, 25466, 25807, 26147, 26484, 26819, 27153, 27484, 27814, 28142, 28467,
  28791, 29114, 29434, 29752, 30069, 30384, 30697, 31008, 31318, 31625, 31931, 32236,
  32538, 32839, 33138, 33435, 33731, 34025, 34317, 34608, 34897, 35184, 35469, 35753,
  36036, 36317, 36596, 36873, 37149, 37424, 37697, 37968, 38238, 38506, 38773, 39038,
  39301, 39563, 39824, 40083, 40341, 40597, 40852, 41105, 41357, 41607, 41856, 42104,
  42350, 42595, 42838, 43080, 43320, 43560, 43797, 44034, 44269, 44503, 44735, 44966,
  45196, 45424, 45652, 45877, 46102, 46325, 46547, 46768, 46987, 47206, 47423, 47638,
  47853, 48066, 48278, 48489, 48699, 48907, 49114, 49321, 49525, 49729, 49932, 50133,
  50333, 50533, 50730, 50927, 51123, 51318, 51511, 51704, 51895, 52085, 52274, 52462,
  52649, 52835, 53020, 53204, 53386, 53568, 53749, 53928, 54107, 54284, 54461, 54636,
  54811, 54985, 55157, 55329, 55499, 55669, 55838, 56005, 56172, 56338, 56503, 56666,
  56829, 56991, 57152, 57313, 57472, 57630, 57788, 57944, 58100, 58255, 58408, 58561,
  58714, 58865, 59015, 59165, 59313, 59461, 59608, 59754, 59900, 60044, 60188, 60331,
  60473, 60614, 60754, 60894, 61033, 61171, 61308, 61444, 61580, 61715, 61849, 61982,
  62115, 62247, 62378, 62508, 62638, 62767, 62895, 63022, 63149, 63275, 63400, 63524,
  63648, 63771, 63893, 64015, 64136, 64256, 64376, 64495, 64613, 64731, 64848, 64964,
  65079, 65194, 65308, 65422, 65535
]);

// DecayCurve gia' complementata: 257 entry 16bit, 65535 -> 0 (discendente), come
// si aspetta ADSRv2.fall(). Usata sia per il decay sia per la release.
export const ADSR_DECAY_257 = new Uint16Array([
  65535, 64722, 63918, 63123, 62338, 61563, 60796, 60039, 59290, 58550, 57819, 57097,
  56383, 55678, 54981, 54292, 53612, 52939, 52275, 51618, 50969, 50328, 49694, 49068,
  48449, 47838, 47233, 46636, 46046, 45463, 44887, 44317, 43755, 43199, 42649, 42106,
  41570, 41040, 40516, 39998, 39486, 38981, 38481, 37988, 37500, 37018, 36541, 36071,
  35605, 35146, 34692, 34243, 33799, 33361, 32928, 32500, 32077, 31659, 31246, 30838,
  30434, 30036, 29642, 29253, 28868, 28488, 28113, 27742, 27375, 27013, 26655, 26301,
  25951, 25605, 25264, 24927, 24593, 24264, 23938, 23616, 23298, 22984, 22674, 22367,
  22064, 21764, 21468, 21176, 20887, 20601, 20319, 20040, 19764, 19492, 19223, 18957,
  18694, 18434, 18177, 17924, 17673, 17425, 17181, 16939, 16700, 16464, 16230, 16000,
  15772, 15547, 15324, 15104, 14887, 14672, 14460, 14250, 14043, 13838, 13636, 13436,
  13238, 13043, 12850, 12660, 12471, 12285, 12101, 11919, 11740, 11562, 11387, 11213,
  11042, 10873, 10705, 10540, 10377, 10215, 10056, 9898, 9743, 9589, 9437, 9286,
  9138, 8991, 8846, 8703, 8561, 8421, 8283, 8146, 8011, 7878, 7746, 7615,
  7487, 7359, 7234, 7109, 6987, 6865, 6745, 6627, 6510, 6394, 6280, 6167,
  6055, 5945, 5836, 5728, 5622, 5516, 5413, 5310, 5208, 5108, 5009, 4911,
  4814, 4718, 4624, 4531, 4438, 4347, 4257, 4168, 4080, 3993, 3907, 3822,
  3738, 3655, 3573, 3492, 3412, 3333, 3255, 3178, 3101, 3026, 2952, 2878,
  2805, 2733, 2662, 2592, 2523, 2454, 2386, 2319, 2253, 2188, 2123, 2059,
  1996, 1934, 1872, 1811, 1751, 1692, 1633, 1575, 1518, 1461, 1405, 1350,
  1295, 1241, 1188, 1135, 1083, 1031, 980, 930, 880, 831, 782, 734,
  687, 640, 594, 548, 503, 458, 414, 370, 327, 285, 243, 201,
  160, 119, 79, 39, 0
]);

// ControlLookup: CV 0..255 -> tuning word 32bit (durate ~0.7ms..11s, 4 decadi log).
// updateAttackCV/DecayCV/ReleaseCV nel firmware indicizzano questa con pot(12bit)>>4.
export const ADSR_TIMECV_TW = new Float64Array([
  196341248, 182558208, 170290432, 159301632, 149402624, 140439808, 132286720, 124839680,
  118011136, 111728128, 105928448, 100559360, 95575296, 90937344, 86611200, 82567168,
  78779648, 75225344, 71884288, 68738560, 65772288, 62971392, 60323072, 57815552,
  55439104, 53184000, 51042048, 49005312, 47067136, 45221120, 43461376, 41782528,
  40179712, 38648576, 37185024, 35784960, 34445056, 33161984, 31932672, 30754304,
  29624320, 28540160, 27499776, 26500608, 25541120, 24619264, 23732992, 22881280,
  22061824, 21273856, 20515584, 19785728, 19083264, 18406912, 17755648, 17128192,
  16523776, 15941376, 15380224, 14839296, 14318080, 13815552, 13330944, 12863488,
  12412928, 11978240, 11559168, 11154688, 10764800, 10388480, 10025216, 9675008,
  9336832, 9010688, 8696064, 8392192, 8099072, 7816192, 7543040, 7279360,
  7025152, 6779648, 6542592, 6313728, 6093056, 5879808, 5674240, 5475584,
  5283840, 5098752, 4920320, 4747776, 4581376, 4420864, 4265728, 4116224,
  3971584, 3832320, 3697664, 3567616, 3442432, 3321344, 3204608, 3091712,
  2982912, 2877952, 2776576, 2678784, 2584320, 2493184, 2405120, 2320384,
  2238464, 2159360, 2083072, 2009600, 1938432, 1870080, 1803776, 1740032,
  1678592, 1618944, 1561600, 1506304, 1453056, 1401600, 1351936, 1303808,
  1257728, 1212928, 1169920, 1128448, 1088256, 1049600, 1012480, 976384,
  941824, 908288, 876032, 844800, 814592, 785664, 757760, 730880,
  704768, 679680, 655360, 632064, 609536, 587776, 566784, 546560,
  527104, 508416, 490240, 472832, 455936, 439552, 423936, 408832,
  394240, 380160, 366592, 353536, 340736, 328704, 316928, 305664,
  294656, 284160, 273920, 264192, 254720, 245504, 236800, 228352,
  220160, 212224, 204800, 197376, 190208, 183552, 176896, 170496,
  164608, 158720, 152832, 147456, 142080, 136960, 132096, 127488,
  122880, 118528, 114176, 110080, 106240, 102400, 98816, 95232,
  91648, 88576, 85248, 82176, 79360, 76544, 73728, 71168,
  68608, 66048, 63744, 61440, 59136, 57088, 55040, 52992,
  51200, 49408, 47616, 45824, 44288, 42752, 41216, 39680,
  38144, 36864, 35584, 34304, 33024, 31744, 30720, 29696,
  28416, 27392, 26624, 25600, 24576, 23808, 23040, 22016,
  21248, 20480, 19712, 19200, 18432, 17664, 17152, 16384,
  15872, 15360, 14848, 14336, 13824, 13312, 12800, 12288
]);
